/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const ChromeDownloadIcon: any = (props: {}) => {
  return (
    <svg width="30px" height="15px" viewBox="40 0 30 90">
      <path
        strokeWidth="10"
        strokeLinecap="round"
        stroke="#000"
        d="M15 20L85 20M15 50L85 50M15 80L85 80"
      />
    </svg>
  );
};

export default ChromeDownloadIcon;
